import { jsx as t } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import l from "@mui/material/Card";
import c from "styled-components";
import { getShadow as m, hexToRgba as n } from "../../theme/utils/styleUtils.js";
const p = {
  root: "cardRoot"
}, f = c(l).withConfig({
  displayName: "StyledCard"
})([
  "&&.cardRoot{margin:0px;display:flex;flex-direction:column;align-items:stretch;color:",
  ";font-size:",
  ";background-color:",
  ";box-shadow:",
  ";border:",
  ";border-color:",
  ";&:hover{background-color:",
  ";}}"
], ({ theme: o }) => o.text.primary, ({ theme: o }) => o.typography.body100.fontSize, ({ theme: o }) => o.isLightTheme ? o.primaryBackground : o.secondaryBackground, ({ $variant: o, theme: r }) => m(r, o), ({ $variant: o }) => o === "outlined" ? "1px solid" : "0px solid", ({ theme: o }) => o.primaryBorder, ({ theme: o, $disableHover: r }) => r ? void 0 : n(o.primaryHover, 0.05)), y = /* @__PURE__ */ s(({ children: o, classes: r, disableHover: a = !0, variant: d = "elevation", ...e }, i) => /* @__PURE__ */ t(f, {
  ...e,
  ref: i,
  classes: {
    ...p,
    ...r
  },
  raised: !1,
  $variant: d,
  $disableHover: a,
  children: o
}));
y.displayName = "Card";
export {
  y as default
};
